import React, { useState } from 'react';
import { isApiError, requestPasswordReset } from '../services/api';

const RequestPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<string>('');
  const [error, setError] = useState<string>('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!email.trim()) return;

    setIsLoading(true);
    try {
      await requestPasswordReset(email.trim());
      setMessage("Si un compte existe pour cet email, un lien a été envoyé. En développement, le lien apparaît dans les logs du serveur.");
    } catch (error) {
      if (isApiError(error) && !error.isNetworkError) {
        // Réponse volontairement neutre : on ne révèle pas si le compte existe.
        setMessage("Si un compte existe pour cet email, un lien a été envoyé.");
      } else {
        setError('Erreur de connexion au serveur. Réessayez.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white rounded-2xl shadow p-6">
      <h1 className="text-2xl font-bold mb-4">Réinitialiser le mot de passe</h1>
      <p className="text-gray-600 mb-6">Entrez votre adresse email pour recevoir un lien de réinitialisation.</p>

      {message && (
        <div className="mb-4 p-3 rounded bg-green-50 text-green-800 text-sm">{message}</div>
      )}
      {error && (
        <div className="mb-4 p-3 rounded bg-red-50 text-red-800 text-sm">{error}</div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">Adresse email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="votre.email@exemple.com"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            required
            disabled={isLoading}
          />
        </div>

        <button
          type="submit"
          disabled={isLoading || !email.trim()}
          className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50"
        >
          {isLoading ? 'Envoi...' : 'Envoyer le lien'}
        </button>
      </form>

      <div className="mt-4 text-sm text-gray-600">
        <a href="/login" className="text-blue-600 hover:underline">Retour à la connexion</a>
      </div>
    </div>
  );
};

export default RequestPasswordPage;


